import { unstable_batchedUpdates } from "react-dom";
import useInterval from "./ui/useInterval";
import { useCallback, useState } from "react";

export default function useUpdateAvailable() {
    const [loadedVersion, setLoadedVersion] = useState<string | null>(null);
    const [deployedVersion, setDeployedVersion] = useState<string | null>(null);

    const fetchVersion = useCallback(() => {
        fetch("/version.txt").then(response => response.text()).then(text => {
            // TODO React 18 automatically batches updates; after upgrading, we can remove unstable_batchedUpdates
            unstable_batchedUpdates(() => {
                setLoadedVersion(version => version == null ? text : version);
                setDeployedVersion(text);
            })
        })
    }, []);

    fetchVersion();
    useInterval(fetchVersion, 60_000);

    return loadedVersion !== deployedVersion;
}